import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useIntl, defineMessages } from 'react-intl';

import { State } from '../../../lib/reducers';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { IconMaximize } from '../../IconSet';

import { expandStreamVideo } from '../../../lib/actions/room';
import { getSelectedStream } from '../../../lib/reduxSelectors/presentationLayout';
import { isFullscreenLayout, isPresentationLayout } from '../../../lib/reduxSelectors/room';
import { RoomLayoutStreamType } from '../../../lib/redux_types';

import useStyles from '../../../style/ControlButton';
import classNames from 'classnames';


const messages = defineMessages({
  foregroundIconButtonTooltip: { id: 'foregroundIconButtonTooltip' },
});


function MoveVideoToMain(props: ExtendedProps) {
  const classes = useStyles();

  const { isPresentationOrFullscreenLayout, isMainVideo, iconSize = 20, mini, uid } = props;

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const moveToMain = () => {
    let streamType: RoomLayoutStreamType = 'stream';
    if (uid.endsWith('_screen')) {
      streamType = 'screen';
    }
    dispatch(expandStreamVideo(uid.replace(/_screen$/, ''), streamType));
  };

  const cls = classNames(classes.controlButton, mini ? classes.controlButtonMini : null);

  if (isPresentationOrFullscreenLayout && !isMainVideo) {
    const msg = formatMessage(messages.foregroundIconButtonTooltip);
    return (
      <Tooltip placement="top" title={msg}>
        <div>
          <IconButton
            onClick={moveToMain}
            className={cls}
            size='small'
          >
            <IconMaximize size={iconSize} />
          </IconButton>
        </div>
      </Tooltip>
    );
  }

  return null;
}


type Props = {
  uid: string;
  iconSize?: number;
  mini?: boolean;
}


type MappedProps = {
  isMainVideo: boolean;
  isPresentationOrFullscreenLayout: boolean;
}


type ExtendedProps = Props & MappedProps


const mapStateToProps = (state: State, { uid }: Props): MappedProps => {
  const selectedStream = getSelectedStream(state);

  return {
    isMainVideo: uid === selectedStream,
    isPresentationOrFullscreenLayout: (isFullscreenLayout(state) || isPresentationLayout(state)),
  };
};


export default connect(mapStateToProps)(MoveVideoToMain);
